import * as React from "react"

class Title extends React.Component {
  render() {
    const scroll = [];
    if(true) {
      scroll.push('data-scroll')
    }
    const Wrapper = ({children}) => {
      if(this.props.heading) {
       var heading = this.props.heading;
      } else {
        heading = 'h1';
      }
      if(this.props.scroll) {
        return(
          <div className={heading+" title--animation pos-rel z-2 w-100 "+this.props.class} data-scroll data-scroll-offset="200">
            {children}
          </div> 
        )
       
      } else {
        return(
          <div className={"title--animation h1 pos-rel z-2 w-100 "+this.props.class} data-scroll-offset="200"><div className="text-center" data-scroll data-scroll-speed="1.5">
             {children}
          </div></div> 
        )
      }
    }
    
    var Line1 = <span className="text-wrapper first"><span className="word p1vw">{this.props.Line1}</span></span> 

    if(this.props.Line2) {
      var Line2 = <span className="text-wrapper second"><span className="word p1vw">{this.props.Line2}</span></span>
    }
    if(this.props.Line3) {
      var Line3 = <span className="text-wrapper third"><span className="word p1vw">{this.props.Line3}</span></span>
    }
    if(this.props.Line4) {
      var Line4 = <span className="text-wrapper fourth"><span className="word p1vw">{this.props.Line4}</span></span>
    }
    return (
      <Wrapper><p className="m0 text-center">
        {Line1}
        {Line2}
        {Line3}
        {Line4}
      </p></Wrapper>
    )
  }
} 

export default Title

